import { parseSpan } from './sourceSpan';
function sourceHasBbox(bbox) {
    return !!bbox && (bbox.width > 0 || bbox.height > 0);
}
// sourceLocation is the 1-based page and highlight the viewer should open
// on. The stated `page` wins; elementIds are 0-based paths (`/page/13/...`)
// and are only used when page is missing. Never treat the path's page as
// already 1-based.
export function sourceLocation(s) {
    const fromElements = s.elementIds[0] ? parseSpan(s.elementIds[0]).page : null;
    const fromBbox = s.bbox && s.bbox.page > 0 ? s.bbox.page : 0;
    const page = s.page > 0 ? s.page : fromElements ?? fromBbox;
    const bbox = sourceHasBbox(s.bbox) ? {
        x: s.bbox.x,
        y: s.bbox.y,
        width: s.bbox.width,
        height: s.bbox.height
    } : undefined;
    return {
        page,
        blocks: [
            ...s.elementIds
        ],
        bbox
    };
}
export function sourceHasLocation(s) {
    const loc = sourceLocation(s);
    return loc.page > 0 || loc.blocks.length > 0 || !!loc.bbox;
}
